import React, { useState } from 'react';
import GovernmentDatabaseCountrySelect from "./GovernmentDatabaseCountrySelect";
import GovernmentDatabaseSelect from "./GovernmentDatabaseSelect";
import GovernmentDatabaseDynamicForm from "./GovernmentDatabaseDynamicForm";
import GovernmentDatabaseDocumentUpload from "./GovernmentDatabaseDocumentUpload";

function GovernmentDatabases({ inputChange, verification }) {
    const [selectedCountry, setSelectedCountry] = useState(null);
    const [selectedDatabase, setSelectedDatabase] = useState(null);

    const handleCountrySelect = (country) => {
        setSelectedCountry(country);
        setSelectedDatabase(null);
    };

    const handleDatabaseSelect = (database) => {
        setSelectedDatabase(database);
    };

    const handleFormSubmit = (formData) => {
        inputChange(formData);
    };

    const handleDocumentUploadComplete = (documentData) => {
        inputChange(documentData);
    };

    const goBackFromDatabaseSelect = () => {
        setSelectedCountry(null);
        setSelectedDatabase(null);
    };

    const goBackFromInput = () => {
        setSelectedDatabase(null);
    };

    const renderInputComponent = () => {
        if (!selectedDatabase) return null;

        if (selectedDatabase.inputType === 'FORM') {
            return (
                <GovernmentDatabaseDynamicForm
                    database={selectedDatabase}
                    country={selectedCountry}
                    goBack={goBackFromInput}
                    onSubmit={handleFormSubmit}
                />
            );
        }

        if (selectedDatabase.inputType === 'DOCUMENT') {
            return (
                <GovernmentDatabaseDocumentUpload
                    database={selectedDatabase}
                    country={selectedCountry}
                    verification={verification}
                    goBack={goBackFromInput}
                    onComplete={handleDocumentUploadComplete}
                />
            );
        }

        return null;
    };

    return (
        <div className="h-full w-full flex flex-col">
            {!selectedCountry && (
                <GovernmentDatabaseCountrySelect onSelect={handleCountrySelect} />
            )}
            {selectedCountry && !selectedDatabase && (
                <GovernmentDatabaseSelect
                    country={selectedCountry}
                    goBack={goBackFromDatabaseSelect}
                    onSelect={handleDatabaseSelect}
                />
            )}
            {selectedDatabase && renderInputComponent()}
        </div>
    );
}

export default GovernmentDatabases;
